import { i18n } from '../i18n/index'

export const saleSortTypes = Object.freeze({
  endTime: {
    str: i18n.com_sort_soonest(),
    order: 'asc',
    num: 2
  },
  popularity: {
    str: i18n.com_sort_popularity(),
    order: 'asc',
    num: 3
  },
  created: {
    str: i18n.com_sort_launch_date(),
    order: 'desc',
    num: ''
  }
})

export const saleStates = Object.freeze({
  // closed: {
  //   openOnly: false,
  //   upcoming: false,
  //   str: i18n.com_closed()
  // },
  actual: {
    openOnly: true,
    upcoming: false,
    str: i18n.com_live()
  },
  upcoming: {
    openOnly: true,
    upcoming: true,
    str: i18n.com_upcoming_only()
  },
  all: {
    openOnly: false,
    upcoming: false,
    str: i18n.com_all()
  }
})

export const saleTypes = Object.freeze({
  crowdfunding: {
    str: i18n.sale_subtype_crowdfunding(),
    type: 'crowdfunding'
  },
  deposit: {
    str: i18n.sale_subtype_deposit(),
    type: 'deposit'
  },
  equity: {
    str: i18n.sale_subtype_equity(),
    type: 'equity'
  },
  all: {
    str: i18n.com_all(),
    type: 'all'
  }
})

export const saleGetList = Object.freeze({
  saleList: 'saleList'
})



// WEBPACK FOOTER //
// ./src/js/const/sales.const.js